import React from "react";
import img from "../../../assets/img/Children.png";
const OrderItems = () => {
  return (
    <>
      <div className=" mt-[50px] mb-[40px] relative mr-auto ml-auto Orders  w-[80%]">
        <div className="flex p-6 justify-between">
          <div className="flex justify-between w-[550px] lg:flex-col">
            <div>
              <h1>Sifariş tarixi:</h1>
              <p className="opacity-50 text-[12px]">28.01.2022</p>
            </div>
            <div>
              <h1>Ünvan:</h1>
              <p className="opacity-50 text-[12px]">Bəşir Səfəroğlu 215</p>
            </div>
            <div>
              <h1>Qiymət:</h1>
              <p className="opacity-50 text-[12px]">50.5</p>
            </div>
          </div>
          <div className="text-end  ">
            <h1 className="flex text-red">
              <svg
                className="mt-[5px] mr-1"
                width="19"
                height="13"
                viewBox="0 0 19 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8327 1L6.37446 12L1.16602 7"
                  stroke="#BB2025"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Çatdırıldı
            </h1>
          </div>

          <hr className="w-[96%] absolute top-[80px] lg:top-[155px]" />
        </div>
        <div className="flex p-5 justify-between lg:flex-col items-center">
          <div className="flex lg:flex-col items-center">
            <div className="flex w-[150px]">
              <img
                className="w-[81px] h-[81px]    border-white object-cover border-solid border-2  rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-40px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-80px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
            </div>
            <div className="sm:flex sm:flex-col lg:mt-2">
              <span className="ml-5">Pasta(x1)</span>
              <span className="ml-5">Burger(x2)</span>
              <span className="ml-5">Lahmacun(x4)</span>
            </div>
          </div>
          <div className="lg:mt-2">
            <button className="bg-red px-[60px] py-2 rounded-[40px] text-white">
              Ətraflı
            </button>
          </div>
        </div>
      </div>
      <div className=" mt-[50px] mb-[40px] relative mr-auto ml-auto Orders  w-[80%]">
        <div className="flex p-6 justify-between">
          <div className="flex justify-between w-[550px] lg:flex-col">
            <div>
              <h1>Sifariş tarixi:</h1>
              <p className="opacity-50 text-[12px]">28.01.2022</p>
            </div>
            <div>
              <h1>Ünvan:</h1>
              <p className="opacity-50 text-[12px]">Bəşir Səfəroğlu 215</p>
            </div>
            <div>
              <h1>Qiymət:</h1>
              <p className="opacity-50 text-[12px]">50.5</p>
            </div>
          </div>
          <div className="text-end  ">
            <h1 className="flex text-red">
              <svg
                className="mt-[5px] mr-1"
                width="19"
                height="13"
                viewBox="0 0 19 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8327 1L6.37446 12L1.16602 7"
                  stroke="#BB2025"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Çatdırıldı
            </h1>
          </div>

          <hr className="w-[96%] absolute top-[80px] lg:top-[155px]" />
        </div>
        <div className="flex p-5 justify-between lg:flex-col items-center">
          <div className="flex lg:flex-col items-center">
            <div className="flex w-[150px]">
              <img
                className="w-[81px] h-[81px]    border-white object-cover border-solid border-2  rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-40px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-80px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
            </div>
            <div className="sm:flex sm:flex-col lg:mt-2">
              <span className="ml-5">Pasta(x1)</span>
              <span className="ml-5">Burger(x2)</span>
              <span className="ml-5">Lahmacun(x4)</span>
            </div>
          </div>
          <div className="lg:mt-2">
            <button className="bg-red px-[60px] py-2 rounded-[40px] text-white">
              Ətraflı
            </button>
          </div>
        </div>
      </div>
      <div className=" mt-[50px] mb-[40px] relative mr-auto ml-auto Orders  w-[80%]">
        <div className="flex p-6 justify-between">
          <div className="flex justify-between w-[550px] lg:flex-col">
            <div>
              <h1>Sifariş tarixi:</h1>
              <p className="opacity-50 text-[12px]">28.01.2022</p>
            </div>
            <div>
              <h1>Ünvan:</h1>
              <p className="opacity-50 text-[12px]">Bəşir Səfəroğlu 215</p>
            </div>
            <div>
              <h1>Qiymət:</h1>
              <p className="opacity-50 text-[12px]">50.5</p>
            </div>
          </div>
          <div className="text-end  ">
            <h1 className="flex text-red">
              <svg
                className="mt-[5px] mr-1"
                width="19"
                height="13"
                viewBox="0 0 19 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8327 1L6.37446 12L1.16602 7"
                  stroke="#BB2025"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Çatdırıldı
            </h1>
          </div>

          <hr className="w-[96%] absolute top-[80px] lg:top-[155px]" />
        </div>
        <div className="flex p-5 justify-between lg:flex-col items-center">
          <div className="flex lg:flex-col items-center">
            <div className="flex w-[150px]">
              <img
                className="w-[81px] h-[81px]    border-white object-cover border-solid border-2  rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-40px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-80px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
            </div>
            <div className="sm:flex sm:flex-col lg:mt-2">
              <span className="ml-5">Pasta(x1)</span>
              <span className="ml-5">Burger(x2)</span>
              <span className="ml-5">Lahmacun(x4)</span>
            </div>
          </div>
          <div className="lg:mt-2">
            <button className="bg-red px-[60px] py-2 rounded-[40px] text-white">
              Ətraflı
            </button>
          </div>
        </div>
      </div>
      <div className=" mt-[50px] mb-[40px] relative mr-auto ml-auto Orders  w-[80%]">
        <div className="flex p-6 justify-between">
          <div className="flex justify-between w-[550px] lg:flex-col">
            <div>
              <h1>Sifariş tarixi:</h1>
              <p className="opacity-50 text-[12px]">28.01.2022</p>
            </div>
            <div>
              <h1>Ünvan:</h1>
              <p className="opacity-50 text-[12px]">Bəşir Səfəroğlu 215</p>
            </div>
            <div>
              <h1>Qiymət:</h1>
              <p className="opacity-50 text-[12px]">50.5</p>
            </div>
          </div>
          <div className="text-end  ">
            <h1 className="flex text-red">
              <svg
                className="mt-[5px] mr-1"
                width="19"
                height="13"
                viewBox="0 0 19 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8327 1L6.37446 12L1.16602 7"
                  stroke="#BB2025"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Çatdırıldı
            </h1>
          </div>

          <hr className="w-[96%] absolute top-[80px] lg:top-[155px]" />
        </div>
        <div className="flex p-5 justify-between lg:flex-col items-center">
          <div className="flex lg:flex-col items-center">
            <div className="flex w-[150px]">
              <img
                className="w-[81px] h-[81px]    border-white object-cover border-solid border-2  rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-40px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
              <img
                className="w-[81px] h-[81px] translate-x-[-80px]  border-white border-solid border-2   object-cover rounded-[14px]"
                src={img}
              />
            </div>
            <div className="sm:flex sm:flex-col lg:mt-2">
              <span className="ml-5">Pasta(x1)</span>
              <span className="ml-5">Burger(x2)</span>
              <span className="ml-5">Lahmacun(x4)</span>
            </div>
          </div>
          <div className="lg:mt-2">
            <button className="bg-red px-[60px] py-2 rounded-[40px] text-white">
              Ətraflı
            </button>
          </div>
        </div>
      </div>
  
  
    </>
  );
};

export default OrderItems;
